<template>
  <div class="content entry-content" id="entry-content">
    <div class="et-tabox">

      <h3 class="tabox-h3"><!-- <span @click="delmodify" class="et-back"><i class="icon-back"></i></span> -->修改报名信息 </h3>

      <div class="form">
        <div v-for="(item,ind) in RegistrationForm">
          <!--text文本-->
          <div class="group" v-if="item.field_type == 'text'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

            <div class="et-typebox et-typeText">
              <input class="form-control" :is_require="item.is_require" :type="item.field_type" :name="item.name"
                     :placeholder="item.tip" :value="item.isChoose" @keyup="SmallKeyup($event,item.rule_type)"/>
              <p class="prompt" style="  font-size: 14px;color: #C8494E;line-height: 25px;display: none">
                请输入正确的{{item.title}}格式！</p>
              <i class="icon-delete" @click="SmallDelete(ind)"></i>
            </div>
          </div>
          <!-- 多行文本-->
          <div class="group" v-if="item.field_type == 'textarea'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

            <div class="et-trbox">
              <textarea class="form-control" rows="3" :is_require="item.is_require" :name="item.name"
                        :placeholder="item.tip" :value="item.isChoose"></textarea>
              <i class="icon-delete"></i>
            </div>
          </div>
          <!--单选-->
          <div class="group" v-if="item.field_type == 'radio'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
            <ul class="et-radiolink" v-if="JSON.parse(item.option_json)">
              <li v-if="item.option_json" v-for="(val,ind) in Math.ceil(JSON.parse(item.option_json).length/2)">
                <div class="et-libox" v-for="(val,i) in 2" v-if="JSON.parse(item.option_json)[ind*2 + i]"
                     @click="sexOn(ind*2 + i,JSON.parse(item.option_json)[ind*2 + i],item.name)">
                  <div
                    :class="JSON.parse(item.option_json)[ind*2 + i] == item.isChoose?'radio-box radio-on'+' '+item.name:'radio-box'+' '+item.name"
                    :is_require="item.is_require" :name="item.name">
                    <input :type="item.field_type" :name="item.name"/>
                  </div>
                  <span>{{JSON.parse(item.option_json)[ind*2 + i]}}</span>
                </div>
              </li>
            </ul>
          </div>
          <!--多选-->
          <div class="group" v-if="item.field_type == 'checkbox'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
            <ul class="et-checklink" :is_require="item.is_require" :name="item.name">
              <li v-if="item.option_json" v-for="(val,ind) in JSON.parse(item.option_json)">
                <div v-if="item.isChoose"
                     :class="JSON.parse(item.isChoose).indexOf(val) != -1?'check-box check-on':'check-box'"
                     :attr-name="val">
                  <input type="checkbox" :name="item.name"/>
                </div>
                <div v-else class="check-box" :attr-name="val">
                  <input type="checkbox" :name="item.name"/>
                </div>
                <span>{{val}}</span>
              </li>
            </ul>
          </div>
          <!--下拉框-->
          <div class="group" v-if="item.field_type == 'select'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

            <div class="et-slebox form-control">
              <select class="form-control select" :name="item.name" :is_require="item.is_require"
                      :value="item.isChoose">
                <option v-if="item.option_json" v-for="(val,ind) in JSON.parse(item.option_json)" :value="val">{{val}}
                </option>
              </select>
              <i class="icon-select"></i>
            </div>
          </div>
          <!--日期-->
          <div class="group" v-if="item.field_type == 'date'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

            <div class="et-typebox et-typeData">
              <!--<p class="time-txt">2019-12-12</p>-->

              <!-- <input class="form-control date-show" type="text" :name="item.name" :is_require="item.is_require"
                     :value="item.isChoose"/>
              <input class="form-control date-style" type="date" name="date" :value="item.isChoose"/>
              <i class="icon-date"></i> -->

                 <input class="form-control date-new-show" type="date"  :name="item.name" :is_require="item.is_require" :value="item.isChoose"/>
            </div>
          </div>
          <!-- 地区-->
          <div class="group content-block" v-if="item.field_type == 'address'">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
            <Linkage @message="listenToMyBoy" :text="item.isChoose"></Linkage>
            <input class="demo1" :title="item.title" style="display: none" :name="item.name"
                   :is_require="item.is_require"
                   type="text">
            <div class="group detailed" style="display: block">
              <label>详细地址<span v-show="item.is_require == 1">*</span></label>
              <div class="et-typebox">
                <input class="form-control" type="text" placeholder="请输入详细地址"/>
              </div>
            </div>
          </div>
          <!-- 所属类型 -->
          <!-- <div class="group group-selmul" v-if="item.field_type =='selectmul'" :is_require="item.is_require" :name="item.name">
            <Cascader :item_data="item"  @change="casChange" />
          </div> -->
          <!-- 所属类型 -->
          <div class="group group-selmul content-block" v-if="item.field_type == 'selectmul'" :is_require="item.is_require" :name="item.name">
            <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
            <Selectmul  :item_data="item" @change="casChange"></Selectmul>
          </div>

          <!--上传视频-->
          <!-- v-show="JSON.parse(UpFile).name == 'uploadvideo'"-->
          <Upload v-if="item.field_type == 'upload' && thirdParty" :UpFile="item" type="1" :id="id" :countArr="countArr"
                  :appId="appId" :audit_level="audit_level"></Upload>

          <VideoUpload v-if="item.field_type == 'uploadvideo' && thirdParty" :UpFile="item" type="1" :id="id"
                       :countArr="countArr"
                       :appId="appId" :audit_level="audit_level"></VideoUpload>
          <!--  上传图片-->
          <!-- v-show="JSON.parse(UpFile).field_type == 'uploadimg'"-->
          <ImageUpload v-if="item.field_type == 'uploadimg' && thirdParty" :UpFile="item" type="1" :id="id"
                       :countArr="countArr"
                       :appId="appId" :audit_level="audit_level"></ImageUpload>
          <!--上传文档-->
          <!-- v-if="UpFile" v-show="JSON.parse(UpFile).field_type == 'uploadfile'" -->
          <FileUpload v-if="item.field_type == 'uploadfile' && thirdParty" :UpFile="item" type="1" :id="id"
                      :appId="appId" :audit_level="audit_level"></FileUpload>
        </div>

      </div>
      <a href="javascript:void(0);" :class="['et-complete',loading||noEdit ?'bg_grey': '']" @click="complete" style="margin-top: 10px">
        {{doEdit}}
      </a>
    </div>
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModalsAler" role="dialog"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <p id="fileMessageM" class="Prompt-p">你确定要删除此条信息？ </p>
          <div class="btn-modal-tw">
            <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal"
               style="width: 50%;display: inline-block">确定</a>
          </div>
        </div>
      </div>
    </div>
    <!--上传过程-->
    <div class="process-modal large-info-modal modal fade" id="processModal" role="dialog" data-backdrop="static"
         aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top:0">
          <div class="modal-body">
            <div class="modal-inner">
              <p class="pl-num">已完成：<span>85</span>%</p>

              <div class="pl-progress">
                <div class="pl-gro-bar" style="width:80%"></div>
              </div>
              <div class="pl-ms-box">
                <p>总大小：<span class="SizeBox">20</span>M</p>

                <p>已上传：<span class="SecondBox">2</span>M</p>

                <!--  <p>时间：<span class="TimeBox">2</span>秒</p>-->
              </div>
              <a href="javascript:void(0);" class="btn-pl-giveup" @click="CloseUpload">取&nbsp;&nbsp;消</a>
            </div>
          </div>
        </div>
      </div>
    </div>
   <!--  <div class="sing-modal upload-modal large-info-modal modal fade" id="editModalsAler2" role="dialog"
         aria-hidden="true" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <p class="Prompt-p">完成参与</p>
          <div class="btn-modal-tw">
            <a href="javascript:void(0);" class="btn-pl-start" style="width: 50%;display: inline-block"
               @click="Determine">确定</a>
          </div>
        </div>
      </div>
    </div> -->
     <!--报名完成-->
    <div class="entry-modal large-info-modal modal fade" id="entryModal" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 50px">
          <div class="modal-body">
            <div class="modal-inner">
              <i class="icon-man"></i>

              <p class="el-txt">{{modalTit}}</p>
              <p style="color:#666;text-align:center;">参与ID：<span style="color:#cf5454">{{userId}}</span></p>
              <a href="javascript:void(0);" class="el-avt" @click="myActivitys" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.form_back&&detailsTxte.page_config.form_back.is_show!='1'"><i class="icon-entry"></i>进入我的活动查看进度</a>

              <a v-bind:href="detailsTxte.page_config.form_back.url" class="btn-el-red btn-el-continue" style="font-size: 16px" v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.form_back&&detailsTxte.page_config.form_back.is_show=='1'"
              >{{detailsTxte.page_config.form_back.title}}</a>

              <a href="javascript:void(0);" v-else class="btn-el-red btn-el-continue" style="font-size: 16px"
                 @click="myActivity">继续参与</a>

              <a href="javascript:void(0);" style="font-size: 16px" class="btn-el-red btn-el-share"
                 @click="share">分享</a>
              <ul class="share" style="display: none;text-align: center;padding-left: 3px">
                <span id="share_1" data-mode="prepend" data-image="" data-sites="weibo,qq,qzone"></span>
              </ul>
              <div id="nativeShare"></div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!--   弹出框-->
    <div class="entry-modal large-info-modal modal fade" id="Alert" role="dialog" data-backdrop="static"
         aria-hidden="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="text-align: center">
          <div class="modal-body">
            <p class="Prompt-p">请确定信息是否填写完成！</p>
            <button class="buttonZ buttonDiv" data-dismiss="modal">确&nbsp;&nbsp;定</button>
          </div>
        </div>
      </div>
    </div>
    <!--分享-->
    <div class="shart" @click="shareHide">
      <img :src="globalUrl + 'static/dist/img/weixin.png'" alt="">
    </div>
  </div>
</template>

<script>

  import Upload from '../UploadToken/upload.vue'
  import FileUpload from '../UploadToken/FileUpload.vue'
  import VideoUpload from '../UploadToken/VideoUpload.vue'
  import ImageUpload from '../UploadToken/imageUpload.vue'
  import Linkage from '../template/linkage.vue'
  // import Cascader from '../template/cascader.vue'
  import Selectmul from '../template/selectmul.vue'

  export default {
    props: [
      // 'id',
      // 'form_id',
      'countArr',
      'userId',
    ],
    data() {
      return {
        id: '',
        form_id: '',
        RegistrationForm: '',
        region: '',
        UpFile: null,  //上传需求
        appId: 'mp0qftl9iu',
        thirdParty: true,
        globalUrl: API.GlobalUrl,
        loading: false,
        modalTit: '信息已提交，感谢您的参与！',
        detailsTxte: '',
        audit_level:2,
        casVal: {},
        noEdit: false,
        doEdit: '修改完成',

      }
    }
    ,
    methods: {
      //操作按钮事件'
      shareHide() {
        $('.shart').hide()
      },
       share() {
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (isWeixin) {
          $('.shart').show()
        }
      },
      myActivity() {//继续参与
        var that = this;
        $('#entryModal').modal('hide');
        // $('.entry-content').hide();
        // this.$router.replace({name: 'myActivity_MyParticipate', params: {id: that.id}})
        this.$router.replace({name: 'Detail', params: {id: that.id}})
      },
      myActivitys() {//查看
        var that = this;
        $('#entryModal').modal('hide');
        this.$router.replace({name: 'myActivity_MyParticipate', params: {id: 0}});
        // window.location.reload();
      },
      CloseUpload() {
        $('#processModal').modal('hide');
      },
      listenToMyBoy(somedata) {
        this.region = somedata
      },
      delmodify() {
        var id = this.$route.params.id;
        if (id && id > 0) {
          // this.$router.replace({name: 'Detail', params: {id: id}});
          this.$router.go(-1);
        } else {
          this.$router.replace({name: 'myActivity_MyParticipate', params: {id: 0}});
          location.reload();
        }

      },
      sexOn(ind, val,item) {
        // radio 选中
        $('.' + item).eq(ind).parent().siblings().children('.' + item).removeClass('radio-on');
        $('.' + item).eq(ind).parents('li').siblings().find('.' + item).removeClass('radio-on');
        $('.' + item).eq(ind).addClass('radio-on')
      },
      Determine() {
        this.$router.replace({name: 'myActivity_MyParticipate', params: {id: 0}})
        location.reload();
      },
      SmallKeyup(event, ruleType) {
        if (ruleType != '' && ruleType) {
          var itself = event.target,
            val = $(itself).val(),
            itselfs = '//' + ruleType + '//',
            re = itselfs.replace(/\/\//g, "\/"),
            reg = eval(re);
          if (!reg.test(val)) {
            $(itself).next().show();
            $('.et-complete').css('pointer-events', 'none');
            return false;
          } else {
            $(itself).next().hide();
            $('.et-complete').css('pointer-events', 'visible');
          }
        }
      },
      complete() {   //完成参与
        var that = this
        if(that.loading ||that.noEdit) {return }//信息提交中
        var file_id = {},
          fileName = $('.load-inner').find('.fileName'),
          that = this,
          content = {};
        //text文本
        var Text = $('.et-typeText');
        for (var t = 0; t < Text.length; t++) {
          //查找每一项
          var TextName = Text.eq(t).find('input');
          //判断是否必填
          if (TextName.attr('is_require') == 1) {
            if (TextName.val() == '') {
              TextName.focus();
              return false;
            }
            if (TextName.attr('name') == 'email') {
              var email = TextName.val();
              var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
              if (reg.test(email)) {

              } else {
                TextName.focus();
                return false;
              }
            }
          }
          content[TextName.attr('name')] = TextName.val()
        }
        //多行文本
        var Textarea = $('.et-trbox');
        for (var te = 0; te < Textarea.length; te++) {
          //查找每一项
          var TextareaName = Textarea.eq(te).find('textarea');
          //判断是否为必填
          if (TextareaName.attr('is_require') == 1) {
            if (TextareaName.val() == '') {
              TextareaName.focus();
              return false;
            }
          }
          content[TextareaName.attr('name')] = TextareaName.val()
        }
        //单选
        var radio = $('.et-radiolink');
        for (var r = 0; r < radio.length; r++) {
          //查找每一项
          var radioName = radio.eq(r).find('.radio-on');
          //判断是否为必填
          if (radio.eq(r).find('.radio-box').attr('is_require') == 1) {
            if (radioName.length == 0) {
              var offset = $('.et-radiolink').eq(r).offset().top;
              $('.et-radiolink').eq(r).addClass('font');
              $(window).scrollTop(offset - 200);
              return false;
            }
          }
          content[radioName.attr('name')] = radioName.next().html()
        }
        //多选
        var checked = $('.et-checklink');
        for (var c = 0; c < checked.length; c++) {
          var che = [];
          //判断是否为必填
          if (checked.eq(c).attr('is_require') == 1) {
            //是否选中
            if (checked.eq(c).find('.check-on').length == 0) {
              var offChecked = $('.et-checklink').eq(c).offset().top;
              $('.et-checklink').eq(c).addClass('font');
              $(window).scrollTop(offChecked - 200);
              return false;
            }
          }
          //遍历多选内容
          for (var cc = 0; cc < checked.eq(c).find('.check-on').length; cc++) {
            che.push($(checked.eq(c).find('.check-on')[cc]).next().html())
          }
          content[checked.eq(c).attr('name')] = JSON.stringify(che)
        }
        //下拉框
        var Select = $('.et-slebox');
        for (var s = 0; s < Select.length; s++) {
          var selectName = Select.eq(s).find('select');
          if (selectName.attr('is_require') == 1) {
            if (selectName.val() == '') {
              var etSlebox = $('.et-slebox').eq(c).offset().top;
              $('.et-slebox').eq(c).addClass('font');
              $(window).scrollTop(etSlebox - 200);
              return false;
            }
          }
          content[selectName.attr('name')] = selectName.val()
        }
        //日期
        var typeData = $('.et-typeData');
        for (var t = 0; t < typeData.length; t++) {
          var typeDateName = typeData.eq(t).find('input').eq(0);
          console.log(typeDateName)
          if (typeDateName.attr('is_require') == 1) {
            if (typeDateName.val() == '') {
              content[typeDateName.attr('name')] = typeDateName.val();
              return false;
            }
          }
          content[typeDateName.attr('name')] = typeDateName.val();
        }
        //地区
        var demolName = $('.demo1');
        if (demolName.length > 0) {
          for (var i = 0; i < demolName.length; i++) {
            var sel = $('.example').eq(i).find('select'),
              selName = '';
            for (var v = 0; v < 3; v++) {
              if (sel.eq(v).val() == '请选择') {
                var etSlebox = $('.content-block').offset().top;
                $('.example').addClass('font');
                $(window).scrollTop(etSlebox);
                return false;
              }
              if (sel.eq(v).length) {
                selName += sel.eq(v).val() + ',';
              } else {
                selName += '--' + ',';
              }
            }

            if (demolName.attr('is_require') == 1) {
              if ($('.detailed').find('input').val() == '') {
                $('#Alert').find('.Prompt-p').html('请填写详细地址');
                $('#Alert').modal('show');
                $('.example').addClass('font');
                return false;
              }
            }
            selName += $('.detailed').find('input').val();
            content[demolName.eq(i).attr('name')] = selName;
          }
        }

       // 所属类型
        var selmul = $('.group-selmul');
        // debugger;
        for(let i=0; i<selmul.length; i++){
          let seli = selmul.eq(i);
          let name = seli.attr('name');
          let casVal  = that.casVal[name];

          if(seli.attr('is_require') == 1){
            // console.log(2)
            if(!casVal || casVal[0] =='' || casVal[1]==''){
             var top = seli.offset().top;
              seli.find('.selmul').addClass('font');
              $(window).scrollTop(top);
              return false;
            }
          }
          if(casVal && casVal.length){
            content[name] = casVal.join();
          }
        }

        var uploadVideo = $('.uploadVideo');
        var uploadImg = $('.uploadImg');
        var uploadFile = $('.uploadFile');
        var uploadAll = $('.uploadAll');

        // 获取上传文件上传字段
        // if (uploadFile.attr('name')) {
        //   content[uploadFile.attr('name')] = '上传文档';
        // }
         if (uploadFile.length) {
            var fLen = uploadFile.find('.fileName')
            var fName = '';
            for (var d = 0; d < fLen.length; d++){
              fName += fLen.eq(d).attr('attr-uuid') + ','
            }
            content[uploadFile.attr('name')] = fName;
          }
        // 获取上传图片或视频
        if (uploadAll.attr('name')) {
          var allLen = uploadAll.find('.fileName')
          var allName = '';
          for (var a = 0; a < allLen.length; a++){
            allName += allLen.eq(a).attr('attr-uuid') + ','
          }
          content[uploadAll.attr('name')] = allName;
        }else{
          // 获取上传视频字段
          if (uploadVideo.length) {
            var videoLen = uploadVideo.find('.fileName')
            var videoName = '';
            for (var d = 0; d < videoLen.length; d++){
              videoName += videoLen.eq(d).attr('attr-uuid') + ','
            }
            content[uploadVideo.attr('name')] = videoName;
          }
          // 获取上传图片字段
          if (uploadImg.length) {
            var imgLen = uploadImg.find('.fileName')
            var imgName = '';
            for (var m = 0; m < imgLen.length; m++){
              imgName += imgLen.eq(m).attr('attr-uuid') + ','
            }
            content[uploadImg.attr('name')] = imgName;
          }
        }
        //上传文件key
        for (var i = 0; i < fileName.length; i++) {
          var key = fileName.eq(i).attr('attr-uuid');
          var val = fileName.eq(i).attr('attr-type');
          file_id[key] = val
        }
        var ActivityForms = {
          activity_id: that.id,
          content: JSON.stringify(content),
          form_id: that.form_id,
          file_id: file_id
        };

        that.loading = true

        $.ajax({
          'url': API.UpdateActivityForm,
          'data': ActivityForms,
          'type': 'POST',
          'dataType': 'json',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          success: function (res) {
            if (res.code == 0) {
              $('#entryModal').modal('show');

              // $('#editModalsAler2').modal('show')
            } else if (res.code == 3002) {
              $('#Alert').find('.Prompt-p').html('活动异常-请联系管理员！');
              $('#Alert').modal('show')
            } else {
              $('#Alert').find('.Prompt-p').html('请确定信息是否填写完成？');
              $('#Alert').modal('show');
            }
          },
          complete: function(){
            that.loading = false;
          }
        })
      },
      casChange(data){
        console.log(data);
        this.casVal[data.name] = data.value;
      }
    }
    ,
    components: {   //渲染页面
      Upload: Upload,
      ImageUpload: ImageUpload,
      FileUpload: FileUpload,
      VideoUpload: VideoUpload,
      Linkage: Linkage,
      // Cascader: Cascader,
      Selectmul: Selectmul
    },
    created: function () {
      var that = this;
      that.id = that.$route.params.id;
      that.form_id = that.$route.params.form_id;
      if(window.isThisClient('cbox')){
        console.log("myparticipate-message");
         that.cboxregisterhandler();
      }

       //账户
      if (!that.loginFn()) {
            $('#login_Alert').modal('show');
            return false;
      } else {
        // console.log('判断是否登录-已登录')
      }
       //100131分享
      if(that.id=="100131"){
        that.modalTit = '全家福上传成功！点击分享按钮，邀请您的朋友参与活动吧！'
      }

      //仅判断报名信息是否可修改
      this.$http.get(API.IsJoin, {params: {activity_id: that.id}})
      .then(function(res){
        if (res.code == 0 && res.data.isJoin != 0) {
          if(res.data.edit_form && res.data.edit_form.is_show ==0){
            that.noEdit = true;
            that.doEdit = res.data.edit_form.title||that.doEdit;
          }
        }
      })


      //报名字段
      //
      function getFormConent(that){
          that.$http.get(API.GetActivityFormContent, {params: {form_id: that.form_id}})
            .then(function (res) {
              if (res.code == 0) {
                var data = res.data;
                var op_default_value;
                
                var _arr = data.map(function (item, val) {
                  op_default_value = item.default_value;
                  //处理错误数据
                  if(item.field_type == 'checkbox'){
                      try {
                        JSON.parse(item.default_value);
                      }
                      catch (e) {
                        op_default_value = JSON.stringify([item.default_value]);;
                      }
                  }
                  
                  // console.log(op_default_value);
                  return {
                    name: item.name,
                    title: item.title,
                    tip: item.tip,
                    field_type: item.field_type,
                    is_require: item.is_require,
                    option_json: item.option_json || '',
                    isChoose: op_default_value || '',
                    choose_num: item.choose_num || '',
                    rule_type: item.rule_type || ''
                  }
                });
                // for()
                that.RegistrationForm = _arr;
              }
              that.$nextTick(function(){
                $('.et-complete').show();
              })
            });
      }

      if(that.form_id != 0){
        getFormConent(that);
      }else{
        that.$http.get(API.GetMyActiviteInfo, {params: {activity_id: that.id}})
         .then(function (res) {
           if(res.code == 0){
               that.form_id = res.data[0].form_id;
               getFormConent(that);
           }
         });
      }

       // 判断安卓机去掉动画
      // that.isAndroid();
      // if(that.id){
        //分享微信
        that.$http.get(API.GetActivitieById, {params: {id: that.id}})
          .then(function (res) {
              // console.log(res,2)
            if (res.code == 0) {
              if (!res.data || res.data.length == 0) {
                that.$router.push({name: 'HomeIndex'})
              }
              var dataTime = new Date(res.data.end_time).getTime() / 1  - new Date().getTime();
              if (dataTime < 0) {
                that.$router.push({name: 'Detail', params: {id: that.id}});
              }
              that.detailsTxte = res.data;
              that.route = that.detailsTxte.playbill.playbill;
            console.log(that.detailsTxte.page_config,'mypart-mess');
            if(that.detailsTxte.page_config.wuxicheck&& that.detailsTxte.page_config.wuxicheck.is_show=="0"){
               that.audit_level = 0;
            }

            }
          });

      // }

    }
    ,
    mounted: function () {
      //操作DOM
      var that = this;

      //选择日期

      // $('.date-show').on('focus', function () {
      //   $('.icon-date').trigger('click');
      // });

      //文本输入框根据内容自动变高
      $('textarea').unbind('input');
      $('textarea').bind('input', function () {
        handleTextareaHeight(this);
      });

      function handleTextareaHeight(element) {
        var textareaMinHeight = 72;
        element.style.height = textareaMinHeight + 'px';
        if (element.scrollHeight > textareaMinHeight) {
          element.style.height = element.scrollHeight + 'px';
        }
      }

    
      // checkbok 选中函数
      $('.form').on('click', '.et-checklink li', function () {
        if ($(this).find('.check-box').hasClass('check-on')) {
          $(this).find('.check-box').removeClass('check-on');
        } else {
          $(this).find('.check-box').addClass('check-on');
        }
      });

      // 日期

      // $('.form').on('click', 'input[type ="date"]', function () {
      //   $(this).parents('.et-typeData').find('.date-show').focus();
      // });

      // $('.form').on('change', 'input[type ="date"]', function () {
      //   $(this).prev('input').val($(this).val())
      // });

      //分享
      var ua = navigator.userAgent.toLowerCase()

      function is_uc() {
        if(navigator.userAgent.indexOf('UCBrowser') > -1) {
          return true;
        } else {
          return false;
        }
      }

      function is_qq() {
        if(ua.indexOf('mqqbrowser')> -1 && ua.indexOf(" qq")<0){
          return true;
        } else {
          return false;
        }
      }

      setTimeout(function () {
       /* $('#entryModal').modal('show')*/
        //判断是否是微信
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (!isWeixin) {
          //判断是否是uc浏览器 或者 qq浏览器
          if (is_uc() || is_qq()) {
            var config = {
              url:  API.UrlName + 'detail/'  + that.id,// 分享的网页链接
              title: that.detailsTxte.title,// 标题
              desc: that.removeTAG(that.detailsTxte.description,100),// 描述
              img: that.detailsTxte.playbill.playbill_h5 || that.detailsTxte.playbill.playbill,// 图片
              img_title: '',// 图片标题
              from:  API.UrlName  // 来源
            };
            var share_obj = new nativeShare('nativeShare', config);
            $('.btn-el-share').hide()
            $('.share').hide()
          }else{
            $('.btn-el-share').hide()
            $('.share').show()
          }

        }
        $('#share_1').share({
          url:  API.UrlName + 'detail/'  + that.id
        });
        var banWimg = $('.dl-banner').width();
        var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
        $('.dl-banner img').css({width: banWimg, height: banHimg, visibility: 'visible'});
      }, 500)

    }

  }
</script>

<style>
 /* #entry-content {
    display: none;
    position: fixed;
    background: #e8e8e8;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    overflow-y: auto;
  }*/

  #entry-content .tabox-h3 {
    text-align: center;
    line-height: 44px;
    font-size: 18px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;;
    position: relative;
  }

  #entry-content .tabox-h3 span {
    position: absolute;
    left: -5px;
    top: -5px;
  }

  #entry-content .tabox-h3 i {
    width: 26px;
    height: 29px;
    background: url(../../../static/dist/img/icon-entry.png) 50% 2px no-repeat;
    background-size: 36px auto;
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
  }
  .shart {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .shart img {
    width: 65%;
    float: right;
    height: auto;
  }
  #entryModal{
    background: rgba(0,0,0,0.5);
  }
  .bg_grey{
    background-color: grey !important;
  }
 @font-face {
    font-family: "socialshare";
    src: url("../../../static/lib/fonts/iconfont.eot");
    src: url("../../../static/lib/fonts/iconfont.eot?#iefix") format("embedded-opentype"),
    url("../../../static/lib/fonts/iconfont.woff") format("woff"),
    url("../../../static/lib/fonts/iconfont.ttf") format("truetype"),
    url("../../../static/lib/fonts/iconfont.svg#iconfont") format("svg")
  }

  .social-share {
    font-family: "socialshare" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale
  }

  .social-share * {
    font-family: "socialshare" !important
  }

  .social-share .icon-tencent:before {
    content: "\f07a"
  }

  .social-share .icon-qq:before {
    content: "\f11a"
  }

  .social-share .icon-weibo:before {
    content: "\f12a"
  }

  .social-share .icon-wechat:before {
    content: "\f09a"
  }

  .social-share .icon-douban:before {
    content: "\f10a"
  }

  .social-share .icon-heart:before {
    content: "\f20a"
  }

  .social-share .icon-like:before {
    content: "\f00a"
  }

  .social-share .icon-qzone:before {
    content: "\f08a"
  }

  .social-share .icon-linkedin:before {
    content: "\f01a"
  }

  .social-share .icon-diandian:before {
    content: "\f05a"
  }

  .social-share .icon-facebook:before {
    content: "\f03a"
  }

  .social-share .icon-google:before {
    content: "\f04a"
  }

  .social-share .icon-twitter:before {
    content: "\f06a"
  }

  .social-share a {
    position: relative;
    text-decoration: none;
    margin: 4px;
    display: inline-block;
    outline: none
  }

  .social-share
  .social-share-icon {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;
    font-size: 20px;
    border-radius: 50%;
    line-height: 32px;
    border: 1px solid #666;
    color: #666;
    text-align: center;
    vertical-align: middle;
    transition: background 0.6s ease-out 0s
  }

  .social-share .social-share-icon:hover {
    background: #666;
    color: #fff
  }

  .social-share .icon-weibo {
    color: #ff763b;
    border-color: #ff763b
  }

  .social-share .icon-weibo:hover {
    background: #ff763b
  }

  .social-share .icon-tencent {
    color: #56b6e7;
    border-color: #56b6e7
  }

  .social-share .icon-tencent:hover {
    background: #56b6e7
  }

  .social-share .icon-qq {
    color: #56b6e7;
    border-color: #56b6e7
  }

  .social-share .icon-qq:hover {
    background: #56b6e7
  }

  .social-share .icon-qzone {
    color: #FDBE3D;
    border-color: #FDBE3D
  }

  .social-share .icon-qzone:hover {
    background: #FDBE3D
  }

  .social-share .icon-douban {
    color: #33b045;
    border-color: #33b045
  }

  .social-share .icon-douban:hover {
    background: #33b045
  }

  .social-share .icon-linkedin {
    color: #0077B5;
    border-color: #0077B5
  }

  .social-share .icon-linkedin:hover {
    background: #0077B5
  }

  .social-share .icon-facebook {
    color: #44619D;
    border-color: #44619D
  }

  .social-share .icon-facebook:hover {
    background: #44619D
  }

  .social-share .icon-google {
    color: #db4437;
    border-color: #db4437
  }

  .social-share .icon-google:hover {
    background: #db4437
  }

  .social-share .icon-twitter {
    color: #55acee;
    border-color: #55acee
  }

  .social-share .icon-twitter:hover {
    background: #55acee
  }

  .social-share .icon-diandian {
    color: #307DCA;
    border-color: #307DCA
  }

  .social-share .icon-diandian:hover {
    background: #307DCA
  }

  .social-share .icon-wechat {
    position: relative;
    color: #7bc549;
    border-color: #7bc549
  }

  .social-share .icon-wechat:hover {
    background: #7bc549
  }

  .social-share .icon-wechat .wechat-qrcode {
    display: none;
    border: 1px solid #eee;
    position: absolute;
    z-index: 9;
    top: -205px;
    left: -84px;
    width: 200px;
    height: 192px;
    color: #666;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px 10px #aaa;
    transition: all 200ms;
    -webkit-tansition: all 350ms;
    -moz-transition: all 350ms
  }

  .social-share .icon-wechat .wechat-qrcode.bottom {
    top: 40px;
    left: -84px
  }

  .social-share .icon-wechat .wechat-qrcode.bottom:after {
    display: none
  }

  .social-share .icon-wechat .wechat-qrcode h4 {
    font-weight: normal;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    background-color: #f3f3f3;
    margin: 0;
    padding: 0;
    color: #777
  }

  .social-share .icon-wechat .wechat-qrcode .qrcode {
    width: 105px;
    margin: 10px auto
  }

  .social-share .icon-wechat .wechat-qrcode .qrcode table {
    margin: 0 !important
  }

  .social-share .icon-wechat .wechat-qrcode .help p {
    font-weight: normal;
    line-height: 16px;
    padding: 0;
    margin: 0
  }

  .social-share .icon-wechat .wechat-qrcode:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -6px;
    bottom: -13px;
    width: 0;
    height: 0;
    border-width: 8px 6px 6px 6px;
    border-style: solid;
    border-color: #fff transparent transparent transparent
  }

  .social-share .icon-wechat:hover .wechat-qrcode {
    display: block
  }

  .shart {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }

  .shart img {
    width: 65%;
    float: right;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/myActivity/MyParticipate-message.vue